import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for M303 (庫位批號庫存量表)
// ============================================================

export interface ReportRequest {
  startLoc?: string;      // 庫位代碼起始 (FM030_01)
  endLoc?: string;        // 庫位代碼結束 (FM030_01)
  startProd?: string;     // 產品代碼起始 (FM030_02)
  endProd?: string;       // 產品代碼結束 (FM030_02)
  startBatch?: string;    // 批號起始 (FM030_03)
  endBatch?: string;      // 批號結束 (FM030_03)
  startDate?: string;     // 入帳日期起始, YYYY-MM-DD
  endDate?: string;       // 入帳日期結束, YYYY-MM-DD
  startSrcBatch?: string; // 來源批號起始 (FM030_59)
  endSrcBatch?: string;   // 來源批號結束 (FM030_59)
  includeZero?: boolean;  // 是否包含零庫存
}

export interface ReportRow {
  fm030_01: string;    // 庫位代碼
  fm030_02: string;    // 產品代碼
  fm030_03: string;    // 批號
  fm030_04: string;    // 品名代碼
  fm030_12: string;    // 倉庫代碼
  fm030_13: string | null; // 入帳日期
  fm030_16: number;    // 庫存量
  fm030_17: number;    // 庫存金額
  fm030_18: number;    // 平均單價
  fm030_19: number;    // 移動加權平均單價
  fm030_24: number;    // 規格值1
  fm030_25: number;    // 規格值2
  fm030_26: number;    // 規格值3
  fm030_27: number;    // 規格值4
  fm030_31: number;    // 在途量
  fm030_32: number;    // 保留量
  fm030_41: number;    // 可用量
  fm030_42: number;    // 總金額
  fm030_51: string;    // 顏色代碼
  fm030_52: string;    // 等級代碼
  fm030_59: string;    // 色名
  fm030_66: string;    // 來源批號
  loc_name: string;    // 庫位名稱
  color_name: string;  // 顏色名稱
}

export interface ReportResponse {
  items: ReportRow[];
  total: number;
}

// ============================================================
// API methods
// ============================================================

export const m303Api = {
  /** Query inventory records with optional filters */
  async getReport(params: ReportRequest): Promise<ReportResponse> {
    const query: Record<string, string> = {};
    if (params.startLoc?.trim()) query['startLoc'] = params.startLoc.trim();
    if (params.endLoc?.trim()) query['endLoc'] = params.endLoc.trim();
    if (params.startProd?.trim()) query['startProd'] = params.startProd.trim();
    if (params.endProd?.trim()) query['endProd'] = params.endProd.trim();
    if (params.startBatch?.trim()) query['startBatch'] = params.startBatch.trim();
    if (params.endBatch?.trim()) query['endBatch'] = params.endBatch.trim();
    if (params.startDate?.trim()) query['startDate'] = params.startDate.trim();
    if (params.endDate?.trim()) query['endDate'] = params.endDate.trim();
    if (params.startSrcBatch?.trim()) query['startSrcBatch'] = params.startSrcBatch.trim();
    if (params.endSrcBatch?.trim()) query['endSrcBatch'] = params.endSrcBatch.trim();
    if (params.includeZero) query['includeZero'] = 'true';
    const res = await apiClient.get('/api/m303/report', { params: query });
    return res.data;
  },
};
